import axios from "axios";

const state = {
  customerLogin: false,
  isAdmin: false,
  report: [],
  testKits: [],
  role: null,
  isLoading: false,
  step: 0,
  outlinerfilters:{},
  showinvkit:false,
  serverTime: null,
};

const mutations = {
  customerLogin(state, boolean) {
    state.customerLogin = boolean;
  },
  saveReport(state, obj) {
    state.report = obj;
  },
  clearReport(state, empty) {
    state.report = empty;
  },
  saveTestKits(state, obj) {
    state.testKits = obj;
  },
  saveRole(state, role) {
    state.role = role;
  },
  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
  setStep(state, step) {
    state.step = step;
  },
  setIsAdmin(state, boolean) {
    state.isAdmin = boolean;
  },
  setViewoutlinerfilters(state, boolean) {
    state.outlinerfilters = boolean;
  },
  setShowinvkit(state, boolean) {
    state.showinvkit = boolean;
  },
  setServerTime(state, time) {
      state.serverTime = time;
    }
};

const actions = {
  fetchServerTime({ commit }) {
      return axios.get('/v1/admin/server-time').then(res => {
        commit('setServerTime', res.data.server_time);
      }) 
  },
  setShowinvkit({ commit }, data) {
    commit("setShowinvkit",data);
  },
  setViewoutlinerfilters({ commit }, data) {
    commit("setViewoutlinerfilters",data);
  },
  adminLoginSet({ commit }){
    if(localStorage.getItem("atoken")) {
      commit("setIsAdmin", true);
    }
  },
  loginCustomer({ commit, dispatch }, data){
    return axios.post(`/v1/customerLogin`,{'id':data.id}).then(res => {
      // commit("setTestKitInfo", res.data.data.testkit);
      // dispatch("sendSearchReq");
      commit("customerLogin", true);
      commit("adminLogined", false);
      commit("setIsAdmin", true);
      dispatch("setCustomerToken", res.data.data.token);
      dispatch("setCustomerTokenSession", res.data.data.token);
      commit("setUser", res.data.data.user);
      return true;
    });
  },
  backtoAdmin({ commit }){
    commit("adminLogined", true);
    commit("setIsAdmin", false);
    commit("customerLogin", false);
    localStorage.removeItem("ctoken");
    sessionStorage.removeItem("ctoken");
    return true;
  },
  setAdminToken({ commit }, token) {
    localStorage.setItem("atoken", token);
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  },
  setCustomerToken({ commit }, token) {
    localStorage.setItem("ctoken", token);
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  },
  setAdminTokenSession({ commit, dispatch }, token) {
    localStorage.removeItem("atoken");
    sessionStorage.setItem("atoken", token);
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  },
  setCustomerTokenSession({ commit, dispatch }, token) {
    localStorage.removeItem("ctoken");
    sessionStorage.setItem("ctoken", token);
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  },
  clearToken({ commit }) {
    localStorage.removeItem("atoken");
    sessionStorage.removeItem("atoken");
    localStorage.removeItem("ctoken");
    sessionStorage.removeItem("ctoken");
    localStorage.removeItem("role");
    sessionStorage.removeItem("role");
    axios.defaults.headers.common["Authorization"] = null;
    commit("clearReport", []);
    commit("customerLogin", false);
    commit("adminLogined", false);
    commit("labLogined", false);
  },
  authentication({ dispatch, commit }, data) {
    commit("setLoading", true);
    return axios.post("/v1/login", data.data).then(res => {
       if (res.data.data.user.roles[0].slug === "customer") {
        commit("saveRole", res.data.data.user.roles[0].slug);
        localStorage.setItem("role", res.data.data.user.roles[0].slug);
        commit(
          "setTestKitId",
          res.data.data.user.testkits[res.data.data.user.testkits.length - 1].id
        );
        data.rememberMe === true
          ? dispatch("setCustomerToken", res.data.data.token)
          : dispatch("setCustomerTokenSession", res.data.data.token);
        commit("changeUserInfo", res.data.data.user);
        commit(
          "saveTestKit",
          res.data.data.user.testkits[res.data.data.user.testkits.length - 1]
        );
        commit("customerLogin", true);
        dispatch("saveNumber", {
          phone: res.data.data.user.phone,
          mail: res.data.data.user.email
        });
        commit("setLoading", false);
        if (
          res.data.data.user.testkits[res.data.data.user.testkits.length - 1]
            .report
        ) {
          commit(
            "saveReport",
            res.data.data.user.testkits[res.data.data.user.testkits.length - 1]
              .report.reportSamples
          );
        }
        commit("setLoading", false);
        return res.data.data.user.roles[0].slug;
      } else {
        commit("saveRole", res.data.data.user.roles[0].slug);
        localStorage.setItem("role", res.data.data.user.roles[0].slug);
        data.rememberMe === true
          ? dispatch("setAdminToken", res.data.data.token)
          : dispatch("setAdminTokenSession", res.data.data.token);
        commit("setLoading", false);
        return res.data.data.user.roles[0].slug;
      }
    }).catch(error => {
          if (error.response && error.response.status === 401) {
            // Incorrect credentials (email or password)
            return Promise.reject({
              type: "auth",
              errors: error.response.data
            });
          }
    });
  },
  getUser({ commit, dispatch }) {
    commit("setLoading", true);
    return axios.get("/v1/customer/testkits").then(res => {
      commit("changeUserInfo", res.data.data.user);
      commit("setUser", res.data.data.user);
      if ( res.data.data.user.testkits.length > 0) {
        commit(
          "saveTestKit",
          res.data.data.user.testkits[res.data.data.user.testkits.length - 1]
        );
      }
      commit("saveTestKits", res.data.data.user.testkits);
      commit("customerLogin", true);
      dispatch("saveNumber", {
        phone: res.data.data.user.phone,
        mail: res.data.data.user.email
      });
      if ( res.data.data.user.testkits.length > 0 && 
        res.data.data.user.testkits[res.data.data.user.testkits.length - 1]
          .report
      ) {
        commit(
          "saveReport",
          res.data.data.user.testkits[res.data.data.user.testkits.length - 1]
            .report.reportSamples
        );
      }
      commit("setLoading", false);
    });
  },
  resetPassword({ commit }, data) {
    return axios.post("/v1/password/forgot", data).then(res => {});
  },
  changePassword({ commit }, data) {
    return axios.post("/v1/password/reset", data).then(res => {});
  },
  changeStep({ commit }, data) {
    commit("setStep", data);
  }
};

const getters  = {
  customerLogin() {
    return state.customerLogin;
  },
  report() {
    return state.report;
  },
  testKits() {
    return state.testKits;
  },
  role() {
    return state.role;
  },
  loading() {
    return state.isLoading;
  },
  getStep() {
    return state.step;
  },
  getIsAdmin() {
    return state.isAdmin;
  },
  getViewoutlinerfilters() {
    return state.outlinerfilters;
  },
  getShowinvkit() {
    return state.showinvkit;
  },
  getServerTime() {
    return state.serverTime;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
